import fr from 'facet-rest';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';

export default fr.metaOverride({ base: BaseWizardStepOverride });
